<template>
    <div >
        <div > 
            <form @submit.prevent="seuilResa_submit">
                <table class="table text-center font-weight-light table-borderless">
                    <tr>
                        <td style="text-align: left; font-weight: bold;">Seuil de déclenchement de l'alarme en {{this.unit_t}}:</td>
                    </tr>
                    <tr>
                        <td COLSPAN="1">

                            <input type="text" id="seuil" class="form-control border-color not-allowed " 
                               @keypress="check_input($event)"
                                placeholder="Entrer le seuil de l'alarme" 
                                v-model="seuil"
                                maxlength="10"
                                required
                                pattern="^\d+(\.\d{1,4})?$"
                                title="au moins 1 chiffre avant la virgule et au plus 4 chiffres après la virgule "
                            >
                        </td>
                    </tr>
                    <tr>
                        <td  class="align-middle" colspan="1">
                            <div  class="text-center mt-4" >
                                <b-button class="btn btn-default mr-3" :disabled="isBusy" @click="$emit('seuilResa-done',{'error' : true,})">Annuler</b-button>
                                
                                <b-button  type="submit" class="btn btn-primary"> Valider </b-button>
                            </div>
                            <div class="alert alert-danger" role="alert" v-if="error">
                                Impossible d'ajouter un seuil ! Veuillez contacter KEMTAG
                                <i class="ti-close float-right mt-1" @click="error = false"></i>
                            </div> 
                        </td>
                    </tr>
                
                </table>
            </form>
        </div>
    </div>
</template>
<script>

export default {
     
    name :"SeuilResa",
    data () {
        return {
            seuil: 0,
            isBusy: false,
            unit: null,
            unit_t: null,
			
             error: false, // initialiser l'objet error {pour la fonction alerte} 
        }
    },
    props :{
        selected_system: {
            type: Object,
            required: false
        },
        
        action : ""
    },
    mounted (){
        
        if(this.selected_system){
            this.seuil =this.selected_system.seuil_hors_resa;
        }
        setTimeout(function() {
            window.dispatchEvent(new Event('resize'));
        }, 250);
    
    },
    created() {
        this.unite();
        this.setValues();
    },
    

    methods : {
        check_input: function(event){
           // autoriser les chiffres  et les nombres décimaux
            if (((event.keyCode >= 48 && event.keyCode <= 57) || event.keyCode === 46) || ((event.which >= 48 && event.which <= 57) || event.which === 46)) {
                // autoriser la saisie de chiffres ou d'un seul point si le point n'est pas déjà présent
                if (event.keyCode === 46 || event.which === 46) {
                    if (event.target.value.indexOf('.') === -1) {
                        return true;
                    } else {
                        event.preventDefault();
                        return false;
                    }
                }
                return true;
            }
            // empêcher toutes les autres touches
            event.preventDefault();
            return false;
        },
        seuilResa_submit() {
            //TODO rajouter le status
            
            this.$store.dispatch('systems/seuil', {               
                id:  this._props.selected_system.id ,
                seuil : this.seuil,
			}).then(resp => {
				this.$emit('seuilResa-done' ,{'error' : false,'resp' : resp});

			}).catch((error) => {
				this.error = true; 
			})
        },
        unite(){
             if(this.selected_system!=null){
                 
                //this.unit = this.selected_system.status;
                this.$store.dispatch('display_unit/getUnit', {
						id: this._props.selected_system.display_unit_id,
                        
				}).then(resp => {
                    const unit = resp.title;
                    this.setValues(unit);
                
				}).catch((error) => {
					this.error = true;
                })
            }
        },
        setValues(unit){
            if(unit=='0'){
                this.unit_t= 'unité';
            }	
            else if(unit=='1'){
                this.unit_t= 'hectare';
            }	
            else if(unit=='2'){
                this.unit_t= 'kilomètre';
            }	
             else if(unit=='3'){
                this.unit_t= 'contact';
            }
             else if(unit=='4'){
                this.unit_t= 'heure';
            }	
             else if(unit=='5'){
                this.unit_t= 'Kwh';
            }
             else if(unit=='6'){
                this.unit_t= 'm³';
            }	
        },
    }
}
</script>
